var map = {
	"./banner-carousel.de-CH.json": 1239,
	"./banner-carousel.de-DE.json": 1240,
	"./banner-carousel.en-CA.json": 1241,
	"./banner-carousel.en-GB.json": 1242,
	"./banner-carousel.en-IN.json": 1243,
	"./banner-carousel.en-ME.json": 1244,
	"./banner-carousel.en-US.json": 1245,
	"./banner-carousel.es-EM.json": 1246,
	"./banner-carousel.es-ES.json": 1247,
	"./banner-carousel.fr-BE.json": 1248,
	"./banner-carousel.fr-CA.json": 1249,
	"./banner-carousel.fr-CH.json": 1250,
	"./banner-carousel.nl-BE.json": 1251,
	"./banner-carousel.nl-NL.json": 1252,
	"./banner-carousel.pl-PL.json": 1253,
	"./banner-carousel.pt-BR.json": 1254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1238;